var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScannerOutline = function SvgScannerOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    width: 250,
    height: 250
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,47C0,21,21,0,47,0h13.4v1.6H47C22,1.6,1.6,22,1.6,47v13.4H0V47z M193,1.6h-13.4V0H193c26,0,47,21,47,47v13.4h-1.6V47 C238.4,22,218,1.6,193,1.6z M1.6,179.6V193c0,25,20.4,45.4,45.4,45.4h13.4v1.6H47c-26,0-47-21-47-47v-13.4H1.6z M238.4,193v-13.4 h1.6V193c0,26-21,47-47,47h-13.4v-1.6H193C218,238.4,238.4,218,238.4,193z"
  })));
};
export default SvgScannerOutline;